module.exports = __webpack_public_path__ + "static/media/13-11.12fa8406.mp3";